<section
  class="home-knowledge-expirations"
  data-section-id="homeia_home_knowledge_expirations"
  *ngIf="featureAvailable"
>
  <header class="hk-header">
    <h3 class="hk-title">{{ lang.translate('home.knowledgeExpirations.title') }}</h3>
    <a class="hk-link" [routerLink]="knowledgeLink">
      {{ lang.translate('home.knowledgeExpirations.viewAll') }}
    </a>
  </header>

  <ul class="hk-list" *ngIf="!loading && !hasError && !isEmpty; else hkState">
    <li class="hk-item" *ngFor="let item of items">
      <span class="hk-date">{{ item.expiresOn | date: 'mediumDate' }}</span>
      <span class="hk-kind">{{ item.kind }}</span>
      <p class="hk-evidence" [title]="item.context">{{ item.originalText }}</p>
    </li>
  </ul>

  <ng-template #hkState>
    <div class="hk-error" *ngIf="hasError; else hkNonError">
      <p class="hk-error-title">{{ lang.translate('home.knowledgeExpirations.errorTitle') }}</p>
      <p class="hk-error-message">{{ lang.translate('home.knowledgeExpirations.errorMessage') }}</p>
      <button type="button" class="btn btn-outline-primary" (click)="onRetry()">
        {{ lang.translate('home.general.retry') }}
      </button>
    </div>
    <ng-template #hkNonError>
      <div class="hk-empty" *ngIf="isEmpty; else hkLoading">
        {{ lang.translate('home.knowledgeExpirations.empty') }}
      </div>
      <ng-template #hkLoading>
        <div class="hk-loading" role="status">{{ lang.translate('home.general.loading') }}</div>
      </ng-template>
    </ng-template>
  </ng-template>
</section>
